// Modules
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Tooltip from 'components/widgets/overlays/tooltip';
import SVG from 'components/widgets/icons/svg';


// Agreement
export default function AgreementMismatch({ item, ...passedProps }) {
  const agreement = item.agreement;
  const ticketAgreement = item.ticket.agreement;
  const agreementMismatch = agreement && ticketAgreement && agreement.id !== ticketAgreement.id;

  if (!agreementMismatch) return null;

  return (
    <Tooltip {...passedProps} title={buildTitle(agreement, ticketAgreement)}>
      <SVG className="agreement-mismatch" src="svg/agreement.svg" />
    </Tooltip>
  );
}

AgreementMismatch.propTypes = {
  item: PropTypes.object.isRequired
};


function buildTitle(agreement, ticketAgreement) {
  return (
    <div>
      Agreement Mismatch<br />
      Agreement: {agreement.title}<br />
      Ticket Agreement: {ticketAgreement.title}
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/components/models/agreement/agreement-mismatch.js